import { render, staticRenderFns } from "./GroupAgg.vue?vue&type=template&id=5e0fc518&scoped=true&"
import script from "./GroupAgg.vue?vue&type=script&lang=js&"
export * from "./GroupAgg.vue?vue&type=script&lang=js&"
import style0 from "./GroupAgg.vue?vue&type=style&index=0&id=5e0fc518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0fc518",
  null
  
)

export default component.exports